<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      clipped
      :expand-on-hover="this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.xl"
      :mini-variant="this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.xl"
      color="#59616b"      
      app     
      transition="fade-transition"      
      v-if="usuarioLogado"
    >
      <v-list dense v-if="companyobj.logoUrl" class="py-3" style="background-color:white;padding: 7px;">
        <v-img :src="companyobj.logoUrl" max-width="-webkit-fill-available;"></v-img>
      </v-list>

      <v-list dense class="py-0" >
        <v-list-item to='/home' @click="textoMenu = 'Dashboard'" active-class="corMenu">
          <v-list-item-action>
            <v-icon dense medium color="white">dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/empresas' @click="textoMenu = 'Empresas'" active-class="corMenu" v-if="user.tipo == 'ADMIN'">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-domain</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Empresas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/planos' @click="textoMenu = 'Planos'" active-class="corMenu" v-if="user.tipo == 'ADMIN'">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-clipboard-text-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Planos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/usuarios' @click="textoMenu = 'Usuários'" active-class="corMenu" v-if="user.tipo == 'ADMIN'">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Usuários</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/alunos' @click="textoMenu = 'Alunos'" active-class="corMenu">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-account-group</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Alunos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/professores' @click="textoMenu = 'Professores'" active-class="corMenu">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-gymnastics</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Professores</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/totens' @click="textoMenu = 'Totens'" active-class="corMenu" v-if="user.tipo == 'ADMIN'">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-monitor-vertical</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Totens</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/paineis' @click="textoMenu = 'Paineis'" active-class="corMenu">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-television</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Painéis</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/editaserviceprofessor' @click="textoMenu = 'Edita Professor'" active-class="corMenu" v-if="user.tipo == 'ADMIN' || user.tipo == 'GERENTE'">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-file-chart</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Relatório de Professores</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/editaservicepainel' @click="textoMenu = 'Edita Professor'" active-class="corMenu" v-if="user.tipo == 'ADMIN' || user.tipo == 'GERENTE'">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-poll</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Relatório de Aulas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/pontoeletronico' @click="textoMenu = 'Ponto Eletrônico'" active-class="corMenu" v-if="user.tipo == 'ADMIN' || companyobj.id == '644c1f8861966b6d635b94ae'">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-calendar-clock</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Ponto Eletrônico</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/resultados' @click="textoMenu = 'Resultados'" active-class="corMenu">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-chart-bell-curve</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Resultados</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to='/auditoria' @click="textoMenu = 'Auditoria'" active-class="corMenu" v-if="user.tipo == 'ADMIN' || user.tipo == 'GERENTE'">
          <v-list-item-action>
            <v-icon dense medium color="white">mdi-shield-search</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Auditoria</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <v-divider></v-divider>
        <v-list-item active-class="corMenu" @click="textoMenu = 'Suporte'">
          <v-list-item-action>
            <img src="../assets/icon-suporte-fechado.png">
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="color:white;word-wrap: break-word;">Suporte</v-list-item-title>            
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-navigation-drawer>

    <v-app-bar
      app
      clipped-left
      v-if="usuarioLogado"
      color="#59616b" height="60"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" style="color: white;"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>

      <!-- MENU USUÁRIO -->    
      <v-menu bottom offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon  dark v-on="on">
            <v-avatar size="40">
              <v-img v-if="user.imagem != ''"  :src="user.imagem"></v-img>
              <v-icon v-else large dark>account_circle</v-icon>
            </v-avatar>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item >
            <v-list-item-avatar>
              <v-img v-if="user.imagem != ''" :src="user.imagem"></v-img>
              <v-icon v-else large light>account_circle</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title style="font-weight: bold;color: grey;">{{user.nome}}</v-list-item-title>
              <v-list-item-subtitle>{{companyobj.nome}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>
      
          <v-list-item  @click.stop="teste()">
              <v-list-item-title>Editar usuário</v-list-item-title>
          </v-list-item>
          <v-list-item @click.stop="abrirAlterarSenha()">
              <v-list-item-title>Alterar senha</v-list-item-title>
          </v-list-item>
          <v-list-item @click.stop="teste()">
              <v-list-item-title>Enviar sugestão</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item @click="Sair()">
            <v-list-item-title>Sair</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>      
    </v-app-bar>

    <!-- DIALOG ALTERAR SENHA (endpoint nativo change-password, exige a senha atual) -->
    <v-dialog v-model="dialogoSenha" persistent max-width="500px" scrollable>
      <v-card>
        <v-card-title>Alterar senha</v-card-title>
        <v-card-subtitle>* indica preenchimento obrigatório</v-card-subtitle>
        <v-card-text style="padding-bottom: 0px">
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Senha atual*"
                outlined
                dense
                hide-details
                v-model="senhaEdit.senhaAtual"
                :type="mostrarSenhaAtual ? 'text' : 'password'"
                :append-icon="mostrarSenhaAtual ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="mostrarSenhaAtual = !mostrarSenhaAtual"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Nova senha*"
                outlined
                dense
                hide-details
                v-model="senhaEdit.novaSenha"
                :type="mostrarNovaSenha ? 'text' : 'password'"
                :append-icon="mostrarNovaSenha ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="mostrarNovaSenha = !mostrarNovaSenha"
              ></v-text-field>
              <!-- Regras da nova senha: todas visíveis, ficam verdes ao serem atendidas -->
              <div class="regrasSenha">
                <div v-for="regra in regrasSenha" :key="regra.texto" :class="regra.ok ? 'regraOk' : 'regraPendente'">
                  <v-icon small :color="regra.ok ? 'success' : 'grey'">{{ regra.ok ? 'mdi-check-circle' : 'mdi-circle-outline' }}</v-icon>
                  {{ regra.texto }}
                </div>
              </div>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Confirmar nova senha*"
                outlined
                dense
                hide-details="auto"
                v-model="senhaEdit.confirmarSenha"
                :type="mostrarConfirmarSenha ? 'text' : 'password'"
                :append-icon="mostrarConfirmarSenha ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="mostrarConfirmarSenha = !mostrarConfirmarSenha"
                :error-messages="erroConfirmacao"
                :success-messages="okConfirmacao"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialogoSenha = false">Fechar</v-btn>
          <v-btn text color="success" :disabled="!podeSalvarSenha" @click="salvarSenha">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbar ref="chamaSnackbar" />
    <loading :active.sync="isLoading" :can-cancel="false" color="#3BA8A2" :is-full-page="true"></loading>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import { baseApiUrl } from '@/global'
  import Snackbar from './snackbar.vue'

  export default {
    components: { Snackbar, Loading },
    props: {
      source: String,
    },
    data() {
      return {
        company: [],
        /* user: [], */
        textoMenu: 'Dashboard',
        drawer: null,
        items: [
          { title: 'Home', icon: 'dashboard' },
          { title: 'About', icon: 'question_answer' },
        ],
        clipped: true,
        mini: false,
        right: null,
        title: 'Controle de Clientes',
        isLoading: false,
        dialogoSenha: false,
        senhaEdit: {
          senhaAtual: '',
          novaSenha: '',
          confirmarSenha: '',
        },
        mostrarSenhaAtual: false,
        mostrarNovaSenha: false,
        mostrarConfirmarSenha: false,
      }
    },

    created () {
      //this.$vuetify.theme.dark = false
    },

    mounted: function () {
      if (sessionStorage.getItem('accToken') != null)
        this.$store.dispatch('Logar', this.token)
      if (sessionStorage.getItem('user') != null)
        this.$store.dispatch('SetUser')
      if (sessionStorage.getItem('company') != null)
        this.$store.dispatch('SetCompany')
    },

    computed: {
      ...mapState({
        usuarioLogado: state => state.isMenuVisible,
        user: state => state.userObj,
        companyobj: state => state.companyObj
      }),

      // Política de senha (a mesma validada no backend, no hook de changePassword).
      regrasSenha() {
        var e = this.senhaEdit
        var nova = e.novaSenha || ''
        return [
          { texto: 'Mínimo de 8 caracteres', ok: nova.length >= 8 },
          { texto: 'Contém letras', ok: /[a-zA-Z]/.test(nova) },
          { texto: 'Contém números', ok: /[0-9]/.test(nova) },
          { texto: 'Diferente da senha atual', ok: !!nova && !!e.senhaAtual && nova !== e.senhaAtual },
        ]
      },

      erroConfirmacao() {
        var e = this.senhaEdit
        return (e.confirmarSenha && e.confirmarSenha !== e.novaSenha) ? 'As senhas não conferem' : ''
      },

      okConfirmacao() {
        var e = this.senhaEdit
        return (e.confirmarSenha && e.confirmarSenha === e.novaSenha) ? 'As senhas conferem' : ''
      },

      podeSalvarSenha() {
        var e = this.senhaEdit
        return !!e.senhaAtual &&
          this.regrasSenha.every(regra => regra.ok) &&
          e.confirmarSenha === e.novaSenha
      },
    },

    methods: {
      Sair() {
        this.$store.dispatch('Sair')
        this.$router.push({ path: '/login' })
      },

      menuSair() {
        this.$router.push({ path: '/' })
      },

      abrirAlterarSenha() {
        this.senhaEdit = {
          senhaAtual: '',
          novaSenha: '',
          confirmarSenha: '',
        }
        this.mostrarSenhaAtual = false
        this.mostrarNovaSenha = false
        this.mostrarConfirmarSenha = false
        this.dialogoSenha = true
      },

      async salvarSenha() {
        var vm = this
        var s = this.senhaEdit
        if (!this.podeSalvarSenha) {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha os campos corretamente para prosseguir", "ATENÇÃO")
          return
        }

        this.isLoading = true
        // Endpoint nativo do model User do LoopBack: verifica a senha atual (oldPassword),
        // opera sobre o usuário do próprio token e encerra as demais sessões dele.
        await axios.post(baseApiUrl + 'Usuarios/change-password?access_token=' + sessionStorage.getItem('accToken'), {
          oldPassword: s.senhaAtual,
          newPassword: s.novaSenha,
        })
        .then(() => {
          this.isLoading = false
          this.dialogoSenha = false
          vm.$refs.chamaSnackbar.snack("green", "Senha alterada com sucesso!", "INFORMAÇÃO")
        })
        .catch(err => {
          this.isLoading = false
          // O nativo devolve "Invalid current password" (code INVALID_PASSWORD) em inglês;
          // as demais regras (hook do backend) já vêm em português.
          var resp = err && err.response && err.response.data
          var msg = 'Erro ao alterar a senha'
          if (resp && resp.error && resp.error.code === 'INVALID_PASSWORD')
            msg = 'Senha atual incorreta.'
          else if (resp && resp.error && resp.error.statusCode === 422 && resp.error.message)
            msg = resp.error.message
          vm.$refs.chamaSnackbar.snack("red", msg, "DESCULPE")
        })
      },
    }
  }
</script>

<style>
  .regrasSenha {
    margin-top: 6px;
    font-size: 13px;
  }

  .regrasSenha .regraPendente {
    color: grey;
  }

  .regrasSenha .regraOk {
    color: #4caf50;
  }

  .v-navigation-drawer {
    width: 60px
  }

  .v-navigation-drawer .v-list .v-list__tile {
    text-decoration: none;
    color: white;
    height: 100%;
    overflow-y: hidden;
    overflow-x: hidden;
  }

  .v-divider {
    margin-top: 0%;
    margin-bottom: 0%;
  }

  .corMenu {
    background-color: #aaaaaa!important;
    border-color: #aaaaaa !important;
  }

  .imagemLogo {
    position:absolute;
    right:50%;
    left:50%;
    margin-right:-50px;
    margin-left:-50px;
  }
  
  .textomenu {
    font-size: 15px;
    position:absolute;
    left:5%;
    color: white;
    /* margin-right:-50px; */
    margin-left:-20px;
  }
  
  hr {
    border: 0;
    width: 100%;
    height: 1px;
    background-image: linear-gradient(to right,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.75),
    rgba(255, 255, 255, 0)
    );
  }

  .titulosmenu {
    font-weight: bold;
    color: grey;
  }
</style>
